interface ImpersonationBannerProps {
  impersonatedUserName: string;
  trueUserName: string;
  stopPath: string;
  csrfToken: string;
}

export function ImpersonationBanner({
  impersonatedUserName,
  trueUserName,
  stopPath,
  csrfToken,
}: ImpersonationBannerProps) {
  return (
    <div
      data-testid="impersonation-banner"
      className="bg-amber-500 text-amber-950 border-b border-amber-700"
    >
      <div className="max-w-6xl mx-auto px-6 py-2 flex items-center justify-between text-sm">
        <span>
          Impersonating <strong>{impersonatedUserName}</strong> (as {trueUserName}).
        </span>
        <form method="post" action={stopPath}>
          <input type="hidden" name="_method" value="delete" />
          <input type="hidden" name="authenticity_token" value={csrfToken} />
          <button
            type="submit"
            className="bg-amber-950 text-white px-3 py-1 rounded text-xs font-medium hover:bg-amber-900 cursor-pointer"
          >
            Stop impersonating
          </button>
        </form>
      </div>
    </div>
  );
}
